import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import Layout from '@/components/layout';

export default function Privacy() {
    return (
        <Layout title="Privacy Policy">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-10 col-xl-8">

                        {/* <!-- Header --> */}
                        <div className="header mt-md-5">
                            <div className="header-body">

                                {/* <!-- Title --> */}
                                <h1 className="header-title display-4">
                                    Datenschutz
                                </h1>

                            </div>
                        </div>

                        <h3>Verantwortlich im Sinne der Datenschutzgesetze:</h3>
                        <p>
                            LOGEX Healthcare Analytics AG<br />
                            Aduchtstraße 7 <br />
                            50668 Köln
                        </p>

                        <h3 className="mt-5">Datenschutz</h3>
                        <p>
                            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.<br />
                            <br />
                            Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben.<br />
                            <br />
                            Wir weisen darauf hin, dass die Datenübertragung im Internet (z.B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.
                        </p>

                        <h3 className="mt-5">Auskunft, Löschung, Sperrung</h3>
                        <p>
                            Zu jedem Zeitpunkt können Sie sich über die personenbezogenen Daten, deren Herkunft und Empfänger und den Nutzen der Datenverarbeitung informieren und unentgeltlich eine Korrektur, Sperrung oder Löschung dieser Daten verlangen.
                            Bitte nutzen Sie dafür die im Impressum angegebenen Kontaktwege.
                            Für weitere Fragen zum Thema stehen wir Ihnen ebenfalls jederzeit zur Verfügung.
                        </p>

                        <h3 className="mt-5">Server-Log Files</h3>
                        <p>
                            Der Seiten-Provider erhebt und speichert automatisch Daten in Server-Log Files, die von Ihrem Browser an uns übermittelt werden. Diese Daten enthalten:<br />
                            <ul>
                                <li>Browsertyp / Browserversion</li>
                                <li>Betriebssystem des Rechners</li>
                                <li>Referrer URL</li>
                                <li>Hostname des zugreifenden Rechners</li>
                                <li>Uhrzeit der Serveranfrage</li>
                            </ul>
                            Diese Daten sind nicht personenbezogen.
                            Es erfolgt keine Zusammenführung dieser Daten mit anderen Datenquellen.
                            Wenn uns konkrete Anhaltspunkte für eine rechtswidrige Nutzung bekannt werden behalten wir uns das Recht vor, diese Daten nachträglich zu überprüfen.
                        </p>

                        <h3 className="mt-5">Cookies</h3>
                        <p>
                            Die Internetseiten verwenden teilweise so genannte Cookies.
                            Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren.
                            Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.
                            Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.<br />
                            <br />
                            Die meisten der von uns verwendeten Cookies sind so genannte „Session-Cookies“.
                            Sie werden nach Ende Ihres Besuchs automatisch gelöscht.
                            Andere Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen.
                            Diese Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.<br />
                            <br />
                            Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren.
                            Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.
                        </p>

                        <h3 className="mt-5">Kontaktformular</h3>
                        <p>
                            Kontaktdaten, die uns über unser Kontaktformular erreichen, werden inklusive des Inhalts der Anfrage für Bearbeitungszwecke und für mögliche Anschlussfragen gespeichert.
                            Diese Daten werden ohne Ihre spezifische Zustimmung nicht weitergegeben.
                        </p>

                        <h3 className="mt-5">Links zu anderen Webseiten</h3>
                        <p>
                            Das Online-Angebot enthält Links zu anderen Websites (sog. externe Links).
                            Wir haben keinen Einfluss darauf, dass die Betreiber anderer Websites die Datenschutzbestimmungen einhalten.<br />
                            <br />
                            Die LOGEX Healthcare Analytics AG ist als Anbieter für eigene Inhalte nach den allgemeinen Gesetzen verantwortlich.
                            Von diesen eigenen Inhalten sind u.U. “Links” auf die von anderen Anbietern bereitgehaltenen Inhalte zu unterscheiden.
                            Für fremde Inhalte, die über Links zur Nutzung bereitgestellt werden und besonders gekennzeichnet sind, übernimmt die LOGEX Healthcare Analytics AG keine Verantwortung und macht sich deren Inhalt nicht zu Eigen.
                            Für illegale, fehlerhafte oder unvollständige Inhalte sowie für Schäden, die durch die Nutzung oder Nichtnutzung der Informationen entstehen, haftet allein der Anbieter der Web-Site, auf die verwiesen wurde.
                            Für fremde Hinweise ist die Redaktion nur dann verantwortlich, wenn sie von ihnen, d.h. auch von einem eventuellen rechtswidrigen bzw. strafbaren Inhalt, positive Kenntnis hat, und es technisch möglich und zumutbar ist, deren Nutzung zu verhindern.
                        </p>

                        <h3 className="mt-5">Änderung der Datenschutzbestimmungen</h3>
                        <p>
                            Unsere Datenschutzerklärung kann in unregelmäßigen Abständen angepasst werden, damit sie den aktuellen rechtlichen Anforderungen entsprechen oder um Änderungen unserer Dienstleistungen umzusetzen, z. B. bei der Einfügung neuer Angebote. Für Ihren nächsten Besuch gilt dann automatisch die neue Datenschutzerklärung.
                        </p>

                        <h3 className="mt-5">Kontakt zum Datenschutzbeauftragten</h3>
                        <p>
                            Ihre Fragen und Anregungen zum Thema Datenschutz sind uns sehr willkommen und wichtig.
                            Sie können uns jederzeit gerne unter datenschutz@hyapp.de kontaktieren.
                        </p>
                    </div>
                </div>
            </div>
        </Layout >
    )
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            ...await serverSideTranslations(locale, ['common', 'menu'])
        }
    }
}
